export const  returnSvgImage: (resource: any, iconName: string) => string = (resource, iconName) => {  

    if(!resource) return;

    const width = resource.svgCode && resource.svgCode != ''  ? resource.svgCode.split('width="')[1] ? resource.svgCode.split('width="')[1].split('" ')[0] : '' : '';
    const height = resource.svgCode && resource.svgCode != ''   ? resource.svgCode.split('height="')[1] ? resource.svgCode.split('height="')[1].split('" ')[0] : '' : '';  
    const strokeAttr = resource.svgCode && resource.svgCode != ''  ? resource.svgCode.split('stroke="')[1] ? resource.svgCode.split('stroke="')[1].split('" ')[0] : '' : '';  
    const fillAttr = resource.svgCode && resource.svgCode != ''  ? resource.svgCode.split('fill="')[1] ? resource.svgCode.split('fill="')[1].split('" ')[0] : '' : '';   
    const strokeWidth = resource.svgCode && resource.svgCode != ''   ? resource.svgCode.split('stroke-width="')[1] ? resource.svgCode.split('stroke-width="')[1].split('" ')[0] : '' : '';    
 
    let w=''; 
    let h=''; 

    if(resource.width){ 
        w='width="'+resource.width+'"'; 
    }else{ 
        w='width="'+width+'"'; 
    }

    if(resource.height){ 
        h='height="'+resource.height+'"'; 
    }else{ 
        h='height="'+height+'"'; 
    }

    let style='style="';
    style+='font-size:'+width+'px;';
    // color:'+strokeAttr+'; -webkit-text-stroke-width:'+strokeWidth+'px;';
    style+='"';

    if(iconName){
        return '<i class="ci ci-'+ iconName +'"  '+style+'  ></i>';
    }
    else{ // (resource.svgCode && strokeAttr !== '' && strokeWidth !== ''){ //} || fillAttr !== 'none'){
        return resource.svgCode;
    }
    /* else{ 
        let svg = "<svg version='1.1' xmlns='http://www.w3.org/2000/svg'  > <image xlink:href='"+resource.src+"' "+w+" "+h+" ></svg>";
        return svg; 
    } */
 }